import { MembershipTier, BillingPeriod } from '../../models/membership.model';
import { CheckBadge } from './MembershipIcons';

export function MembershipCard({ tier, billing, onBecomeMember, checkoutLoading, dgeEnabled, onDgeToggle }: { tier: MembershipTier; billing: BillingPeriod; onBecomeMember?: (membershipId?: string) => void; checkoutLoading?: boolean; dgeEnabled?: boolean; onDgeToggle?: () => void }) {
   const isAnnual = billing === 'annual' && !tier.monthlyOnly;
   const displayMultiplier = isAnnual ? tier.multiplier.annual : tier.multiplier.monthly;

   const isCurrent = tier.action === 'current';
   const isUpgrade = tier.action === 'upgrade';
   const isDowngrade = tier.action === 'downgrade';

   const ctaLabel = checkoutLoading
      ? 'Loading...'
      : isCurrent
        ? 'Current Plan'
        : isUpgrade
          ? 'Upgrade'
          : isDowngrade
            ? 'Downgrade'
            : tier.cta;

   return (
      <div className={`membership-card ${tier.slug}${tier.popular ? ' popular' : ''}${isCurrent ? ' current' : ''}`}>
         {/* Title */}
         <div className="card-header">
            <div className="card-title-row">
               <h3>{tier.name}</h3>
               {isCurrent && <span className="current-badge">Current</span>}
               {!isCurrent && tier.popular && <span className="popular-badge">Most Popular</span>}
            </div>
         </div>

         {/* Multiplier */}
         <div className="card-multiplier">
            <span className="multiplier-value">{displayMultiplier}</span>
            <span className="multiplier-x">×</span>
            <p className="multiplier-label">Points Multiplier</p>
            <p className="multiplier-desc">One round does the work of {displayMultiplier}.</p>
         </div>

         {/* Pricing */}
         <div className="card-pricing">
            <span className="price">
               ${isAnnual ? tier.price.annualPerMonth.toFixed(2) : tier.price.monthly.toFixed(2)}
            </span>
            <span className="price-period">/mo</span>
            {isAnnual ? (
               <span className="annual-price">Billed annually ${tier.price.annualTotal.toLocaleString()}</span>
            ) : (
               <span className="annual-price">Billed monthly</span>
            )}
         </div>

         {/* CTA */}
         <button
            className={`card-cta${isCurrent ? ' card-cta-current' : ''}${isDowngrade ? ' card-cta-downgrade' : ''}`}
            onClick={() => !isCurrent && onBecomeMember?.(tier.id)}
            disabled={checkoutLoading || isCurrent}
         >
            {ctaLabel}
         </button>

         {/* Features */}
         <div className="card-features">
            {/* Daily Grind Elite — hidden for now
            <div className="feature-row">
               <div className="feature-icon">
                  <img src={tier.icons.dge} alt="Daily Grind Elite" />
               </div>
               <div className="feature-text">
                  <span className="feature-name dge-name">
                     Daily Grind Elite
                  </span>
                  {tier.dgeToggle && <span className="feature-sub">Included with Silver &amp; above</span>}
               </div>
               {tier.dgeIncluded ? (
                  <img className="feature-check" src="/assets/icons/memberships/check-feature.svg" alt="" width={19} height={12} />
               ) : (
                  <div className="dge-right">
                     <div
                        className={`toggle-track${dgeEnabled ? ' toggle-active' : ''}`}
                        onClick={onDgeToggle}
                        role="switch"
                        aria-checked={dgeEnabled}
                        style={{ cursor: onDgeToggle ? 'pointer' : 'default' }}
                     >
                        <div className={`toggle-knob${dgeEnabled ? ' toggle-knob-active' : ''}`} />
                     </div>
                     {tier.dgePrice && <span className="toggle-price">{tier.dgePrice}</span>}
                  </div>
               )}
            </div>
            */}

            {/* Bonus sweepstakes entries */}
            <div className="feature-row">
               <div className="feature-icon">
                  <img src={tier.icons.entry} alt="Sweepstakes" />
               </div>
               <div className="feature-text">
                  <span className="feature-name">Bonus entries per sweepstakes</span>
               </div>
               <span className="feature-value">{tier.sweepstakesEntries.toLocaleString()}</span>
            </div>

            {/* PYL spins */}
            <div className="feature-row">
               <div className="feature-icon">
                  <img src={tier.icons.spin} alt="Press Your Luck" />
               </div>
               <div className="feature-text">
                  <span className="feature-name">{tier.pylLabel}</span>
               </div>
               <span className="feature-value">{tier.pylSpins}</span>
            </div>
         </div>

         {/* Divider */}
         <div className="card-divider" />

         {/* Checklist */}
         <div className="card-checklist">
            {tier.checklist.map((item, i) => (
               <div className="checklist-item" key={i}>
                  <CheckBadge />
                  <span>{item}</span>
               </div>
            ))}
         </div>
      </div>
   );
}
